/**
 * 发行平台-藏品订单支付页
 */
import './index.scss'
import NFTHeader from "@/components/NFTHeader";
import React, {useEffect, useReducer, useRef, useState} from "react";
import Error from "@/view/Error";
import {useLocation, useNavigate} from "react-router-dom";
import {computeNumber, getUrlAllParams, isArray, isIOSNew, round} from "@/utils/publicFun";
import ShopEditBox from "@/view/ape/PayPage/component/ShopEditBox";
import ReturnPoints from "@/view/nftPad/payPage/components/ReturnPoints";
import {Checkbox, Toast} from "antd-mobile";
import rc from '../images/red-cheked.png'
import wc from '../images/white-check.png'
import PayTypeSelect from "@/view/ape/PayPage/component/PayTypeSelect";
import TotalInfoBox from "@/view/ape/PayPage/component/TotalInfoBox";
import {hideLoading, showLoading} from "@/components/loading";
import appService from "@/utils/appService";
import {getProductList, checkNotpay, getPrepayDetail, getUserInfo} from "@/api/projectManager_self";
import JsBridgeNew from "@/utils/jsbridgeNew";
import BottomBtn from "@/view/nftPad/payPage/components/BottomBtn";

const PayPage = () => {
  const navigate = useNavigate()
  const {search} = useLocation()
  const param = getUrlAllParams(search.slice(1))
  const [deductionPrice, setDeductionPrice] = useState(0)
  const [deduction, setDeduction] = useState(false)
  const [originTotalPrice, setOriginTotalPrice] = useState(0) // 积分未抵扣前的总金额
  const [totalPoints, setTotalPoints] = useState(0) // 用户持有的总积分
  const {
    collectionId = '', //藏品id
    saleBatchId = '',
    hasIntegralDeduction,
    // hasComicIntegral,
    activityCode,
  } = param
  const [state, dispath] = useReducer((state,action)=> {
    //数据处理
    if(JSON.stringify(state) != JSON.stringify(action)) {
      return {
        ...state,
        ...action
      }
    }
    return state
  }, {
    // 设置state初始值
    errorContext:'',
    userInfo: {},
    payDetail:{},
    payType:'',
    salePrice: 0,
    totalPrice: 0,
    count: 1,
    // ios恢复购买开关：codeName 0关闭 1打开
    showRestorePurchase: false,
  });
  const notPayOrder = useRef(false)
  const verifyRealName = useRef(true)

  //获取用户信息
  const queryUserInfo = async () => {
    const {code, msg, data} = await getUserInfo();
    if (code !== '000000') throw msg;
    return data;
  }
  //获取支付信息
  const getPayDetail = async () => {
    const params = {
      collectionId: collectionId,
      saleBatchId:saleBatchId,
      activityCode,
    };
    const {code, msg, data} = await getPrepayDetail(params);
    if (code !== '000000') throw msg;
    return data;
  }
  //有无待支付订单
  const checkIsHasNotPay = async (collectionType) => {
    const {code, msg, data} = await checkNotpay({collectionType: collectionType || ''});
    if (code !== '000000') throw msg;
    if (data?.notPayOrderCnt) {
      Toast.show("您有待付款的订单，请先完成上次订单")
      notPayOrder.current = true
    }
  }
  // 获取 ios 恢复购买开关（serviceCode 600077，codeName 0关闭 1打开）
  const fetchIosRestorePurchaseSwitch = async () => {
    if (!isIOSNew() || !window.JsBridge?.hasWebViewBridge?.()) return false;
    try {
      const res = await appService('600077', { codeType: 'iosRestorePurchaseSwitch', code: '1' }, false);
      if (!res) return false;
      const result = res?.data?.result ?? res?.result;
      let codeName = result?.defCode?.codeName;
      if (codeName === undefined && Array.isArray(result?.list)) {
        const item = result.list.find(
          (i) => i?.codeType === 'iosRestorePurchaseSwitch' || i?.code === '1'
        );
        codeName = item?.defCode?.codeName ?? item?.codeName;
      }
      if (codeName === undefined) {
        codeName = result?.defCode?.codeName ?? result?.codeName;
      }
      // 仅当 codeName 明确为 '1' 时显示，其余（含接口失败、异常、未返回）均不显示
      return String(codeName) === '1';
    } catch (e) {
      return false;
    }
  };

  const loadPageData = async () => {
    try {
      showLoading();
      const [userInfo, payDetail, showRestorePurchase] = await Promise.all([
        queryUserInfo(),
        getPayDetail(),
        fetchIosRestorePurchaseSwitch(),
      ]);
      await checkIsHasNotPay(payDetail?.collectionType);
      hideLoading();
      const deductionPrice = computeNumber(payDetail?.price, "*", payDetail?.pointRatio).result >= userInfo.point ? computeNumber(userInfo.point, "/", payDetail?.pointRatio).result : payDetail?.price
      setDeductionPrice(computeNumber(deductionPrice, "*", 1).result)
      dispath({
        userInfo: userInfo ||{},
        payDetail: payDetail||{},
        showRestorePurchase: !!showRestorePurchase,
      })
      // setTotalPoints(500)
      setTotalPoints(userInfo.point)
      // setPayDetail()

    } catch (error) {
      hideLoading();
      if(process.env.NODE_ENV !== 'development') {
        dispath({errorContext: error})
      }
      Toast.show(error);
    }
  }

  useEffect(()=>{
    if (!collectionId) {
      Toast.show("参数不合法");
      if(process.env.NODE_ENV !== 'development') {
        dispath({errorContext: '参数不合法'})
      }
    } else {
      if (window.JsBridge.hasWebViewBridge()) {
        window.JsBridge.setTitle('订单支付')
        window.JsBridge.verifyRealName("请先实名认证").then((res)=> {
          verifyRealName.current = !!res?.result
        })
      }
      loadPageData()
    }

  },[])

  const gotoSalePaySuccess = (list) => {
    navigate(`/nftPad/PaySuccess`, {
      state: {
        collectionList: list || [],
      },
      replace: true
    })
  }

  const gotoPending = (params) => {
    navigate(`/nftPad/PaySuccess`, {
      state: {
        pay_query: params,
      },
      replace: true
    })
  }
  const gotoOrderList = () => {
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.replace("Web", {uri: `${window.location.origin}/myGroupOrder`});
    } else {
      navigate(`/myGroupOrder`, {replace: true})
    }

  }

  // 恢复购买功能
  const restorePurchases = async () => {
    if (!window.ReactNativeWebView) {
      Toast.show('当前环境不支持恢复购买');
      return;
    }

    try {
      showLoading();

      // 先初始化商品列表（恢复购买需要先初始化商品列表）
      console.log('开始初始化商品列表...');
      const productResult = await getProductList({});

      if (productResult.code !== '000000') {
        hideLoading();
        Toast.show(productResult?.msg || '获取商品列表失败');
        return;
      }

      if (!productResult.data || !isArray(productResult.data) || productResult.data.length === 0) {
        hideLoading();
        Toast.show('获取苹果支付商品失败');
        return;
      }

      // 初始化商品列表到原生端
      console.log('初始化商品列表到原生端:', productResult.data);
      JsBridgeNew.iapProList(JSON.stringify(productResult.data));

      // 等待一小段时间确保商品列表初始化完成
      await new Promise(resolve => setTimeout(resolve, 500));

      const callbackName = 'restorePurchasesCallback';
      let timeoutId = null;

      // 设置超时处理（30秒）
      timeoutId = setTimeout(() => {
        if (window[callbackName]) {
          console.warn('恢复购买超时，清理回调函数');
          delete window[callbackName];
          hideLoading();
          Toast.show('恢复购买超时，请稍后重试');
        }
      }, 30000);

      // 设置全局回调函数
      window[callbackName] = function(result) {
        // 清除超时
        if (timeoutId) {
          clearTimeout(timeoutId);
          timeoutId = null;
        }

        hideLoading();
        console.log('恢复购买回调收到结果:', result);

        try {
          // 解析结果 - 支持多种格式
          let resultData = result;

          // 如果是字符串，尝试解析
          if (typeof result === 'string') {
            try {
              resultData = JSON.parse(result);
            } catch (e) {
              console.error('解析结果失败:', e);
              resultData = { data: { code: '-1', message: result } };
            }
          }

          console.log('解析后的结果数据:', resultData);

          // 处理不同的响应格式
          // 格式1: { status: 1, data: { code: '200', ... } }
          // 格式2: { data: { code: '200', ... } }
          // 格式3: { code: '200', ... }
          const status = resultData.status;
          const data = resultData.data || resultData;
          const code = data?.code || resultData.code;

          if ((status === 1 || status === undefined) && code === '200') {
            // 恢复成功
            const restoredCount = data.restoredCount || 0;
            Toast.show(`恢复成功!恢复了${restoredCount}笔交易`);

            // 处理恢复的交易
            const transactions = data.transactions || [];
            if (Array.isArray(transactions) && transactions.length > 0) {
              transactions.forEach(transaction => {
                console.log('恢复产品:', transaction.productId);
                // 这里可以添加更新购买状态的逻辑
              });
            }
          } else if (code === '0') {
            // 没有可恢复的购买记录
            Toast.show('没有可恢复的购买记录');
          } else {
            // 恢复失败
            const errorMsg = data?.message || resultData.message || '恢复失败';
            console.error('恢复购买失败，错误信息:', errorMsg, '完整结果:', resultData);
            Toast.show(`恢复失败: ${errorMsg}`);
          }
        } catch (error) {
          console.error('恢复购买回调处理错误:', error, '原始结果:', result);
          Toast.show('恢复购买处理失败，请稍后重试');
        } finally {
          // 清理回调函数
          try {
            delete window[callbackName];
          } catch (e) {
            console.error('清理回调函数失败:', e);
          }
        }
      };

      // 发送消息到原生端
      const message = {
        method: 'iapRestore',
        data: { actionName: callbackName }
      };

      console.log('发送恢复购买消息:', message);
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
    } catch (error) {
      hideLoading();
      console.error('恢复购买初始化失败:', error);
      Toast.show('恢复购买初始化失败，请稍后重试');
    }
  }

  /*const setPayDetail = () => {
    dispath({
      payDetail: {
        price: data.blindBoxInfo.price,
        imageBg: data.blindBoxInfo.boxImage,
        collectionName: data.blindBoxInfo.boxName,
        saleBatchInfo: {
          stock: 12,
          soldDisplay: 7
        }
      },
    })
  }*/

  useEffect(() => {
    let allNeedPrice = state.payDetail?.price ? computeNumber(state.payDetail.price, "*", state?.count).result : 0
    if (deduction) {
      let allNeedPoint = computeNumber(allNeedPrice, "*", state.payDetail?.pointRatio).result

      let deductionPrice2 = allNeedPoint >= totalPoints ? computeNumber(totalPoints, "/", state.payDetail?.pointRatio).result : allNeedPrice
      setDeductionPrice(computeNumber(deductionPrice2, "*", 1).result)
      dispath({
        totalPrice: computeNumber(allNeedPrice, "-", deductionPrice2).result
      })
    } else {
      dispath({
        totalPrice: allNeedPrice
      })
    }
  }, [state.count, deduction])
  /** 积分抵扣-商品金额卡片 */
  const integralDeductionRender = () => {
    return (
      <div className="point-amount-card">
        <div className="row mb-12">
          <div className="label">商品金额</div>
          <div className="value-text">¥{state.payDetail?.price && round(state.payDetail?.price * state.count, 2)}</div>
        </div>
        {state.payDetail?.pointRatio > 0 && (
          <div>
            <div className="row">
              <div className="label">积分抵扣</div>
              <Checkbox
                defaultChecked={deduction}
                onChange={(checked) => setDeduction(checked)}
                icon={checked => <img className="use-point-checkbox-img" src={checked ? rc : wc} alt="" /> }
              />
            </div>
            <div className="tip-msg">我的积分: {totalPoints} ({state.payDetail?.pointRatio}积分可抵扣1元)</div>
          </div>
        )}
        <div className="amount-row">
          <span className="total-text">总计：</span>
          {deduction && <span className="point-tip">积分抵扣：{round(deductionPrice * state.payDetail?.pointRatio, 0)}(-￥{round(deductionPrice, 2)})</span>}
          <span className="amount-num" style={{ marginLeft: deduction ? null : 0}}>¥{round(state.totalPrice || 0, 2)}</span>
        </div>
      </div>
    )
  }
  const contentRender = () => {
    return (
      <div className="pad_pay_page--body">
        <div className="body-content">
          <ShopEditBox
            userInfo={state.userInfo}
            payDetail={state.payDetail}
            maxCount={10}
            showPurchaseMax={true}
            onPriceChange={(totalPrice, count)=> {
              setOriginTotalPrice(totalPrice)
              dispath({
                count: count,
                totalPrice: totalPrice
              })
            }}
          />
          {!hasIntegralDeduction && <TotalInfoBox payDetail={{totalPrice: state.totalPrice}}/>}
           { /*画返积分*/ }
          {state.payDetail.comicsSet && state.payDetail.pointPercentage && <ReturnPoints data={{
            totalPrice: originTotalPrice,
            comicsSet: state.payDetail.comicsSet,
            pointPercentage: state.payDetail.pointPercentage,
            pointRatio: 100,
          }}/>}
          {hasIntegralDeduction && integralDeductionRender()}
          <PayTypeSelect onChange={(pay)=>dispath({payType: pay.payType})}/>
          {
            // 只在 iOS 且接口开关打开时显示恢复购买按钮（codeName 0关闭 1打开）
            isIOSNew() && window.JsBridge?.hasWebViewBridge?.() && state.showRestorePurchase && (
              <div className="restore-purchases-container">
                <button
                  className="restore-purchases-btn"
                  onClick={restorePurchases}
                >
                  恢复购买
                </button>
              </div>
            )
          }
        </div>
        <div className="bottom">
          <BottomBtn
            userInfo={state.userInfo}
            payDetail={{...state.payDetail, count: state.count, totalPrice: state.totalPrice}}
            param={param}
            usePoint={deduction ? round(deductionPrice * state.payDetail?.pointRatio, 0) : 0}
            verifyRealName={verifyRealName.current}
            notPayOrder={notPayOrder.current}
            payWay={state.payType}
            collectionId={collectionId}
            callback={(result) => {
              if(result.code == 'success') {
                gotoSalePaySuccess(result.data)
              }else if((result.code == 'pending')){
                // 不等待支付结果，直接跳转
                gotoPending(result.data)
              }else {
                gotoOrderList()
              }
            }}
          />
        </div>
      </div>
    )
  }
  return (
    <div className="pad_pay_page">
      {
        !window.JsBridge.hasWebViewBridge() && <NFTHeader midText="订单支付" bgColor="white"/>
      }
      {state.errorContext ? <Error context={state.errorContext}/>: contentRender()}
    </div>
  )
}
export default PayPage
